var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{ref:"mainCon",staticClass:"main-container",class:{
            'full-board': !_vm.isActive,
            hovered: _vm.isHover,
            scrolled: _vm.windowTop > 100 && _vm.windowCalc,
            'no-filters': _vm.noFilters,
            'is-home': _vm.isHome,
            'no-tabs': _vm.noTabs,
            'filter-over-tabs': _vm.filterOverTabs,
            'bip-model': _vm.bipModel,
        },style:(_vm.mainContainerStyles),attrs:{"id":"main-container"},on:{"scroll":_vm.onScroll}},[(_vm.userModulesLoaded && _vm.areComponentsShowed)?_c('c-board'):_vm._e(),(_vm.areComponentsShowed)?_c('c-menu'):_vm._e(),(_vm.areComponentsShowed)?_c('c-board-right'):_vm._e(),_c('router-view'),_c('div',{staticClass:"overlay",on:{"click":function($event){_vm.isActive = !_vm.isActive}}})],1),_c('video-player')],1)}
var staticRenderFns = []

export { render, staticRenderFns }